import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Provider } from 'react-redux';
import { AuthProvider } from './auth/AuthContext';
import { store } from './store/store';
import ProtectedRoute from './components/Auth/ProtectedRoute';
import Layout from './components/Layout/Layout';
import Home from './pages/Home';
import Login from './pages/Login';
import Consultation from './pages/Consultation';
import History from './pages/History';
import Patients from './pages/Patients';
import Statistics from './pages/Statistics';
import Settings from './pages/Settings';

/**
 * QualiteeMed.ai Frontend Application
 * Healthcare AI-powered voice-to-structured-text platform
 */
function App() {
  return (
    <Provider store={store}>
      <AuthProvider>
        <Router>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/" element={<Layout />}>
              <Route index element={<Home />} />
              <Route path="consultation" element={<ProtectedRoute><Consultation /></ProtectedRoute>} />
              <Route path="history" element={<ProtectedRoute><History /></ProtectedRoute>} />
              <Route path="patients" element={<ProtectedRoute><Patients /></ProtectedRoute>} />
              <Route path="statistics" element={<ProtectedRoute><Statistics /></ProtectedRoute>} />
              <Route path="settings" element={<ProtectedRoute><Settings /></ProtectedRoute>} />
              {/* Redirect old routes to new ones */}
              <Route path="dashboard" element={<Navigate to="/consultation" replace />} />
              <Route path="profile" element={<Navigate to="/settings" replace />} />
              <Route path="voice" element={<Navigate to="/consultation" replace />} />
              <Route path="reports" element={<Navigate to="/statistics" replace />} />
            </Route>
          </Routes>
        </Router>
      </AuthProvider>
    </Provider>
  );
}

export default App; 